module.exports = __webpack_public_path__ + "static/media/fr.97c899e5.svg";